import { render, staticRenderFns } from "./sale-episodes.vue?vue&type=template&id=5b365864&scoped=true&lang=html&"
import script from "./sale-episodes.vue?vue&type=script&lang=js&"
export * from "./sale-episodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b365864",
  null
  
)

export default component.exports